import { LocaleEnum } from '@systemeio/types'
import { getLocaleLanguage, type TFunctionType } from '@systemeio/util'

export const getLocaleSelectOptions = (t: TFunctionType): { id: LocaleEnum; caption: string }[] =>
  Object.values(LocaleEnum).map(locale => ({
    id: locale,
    caption: getLocaleLanguage(locale, t),
  }))

// export const getFullySupportedLocaleSelectOptions = (
//   t: TLocoType,
// ): { id: FullySupportedLocaleEnum | undefined; caption: string }[] =>
//   Object.values(FullySupportedLocaleEnum).map(locale => ({
//     id: locale,
//     caption: t(fullySupportedLocaleLanguages[locale]),
//   }))
